import { X } from 'lucide-react';
import { cn } from 'utils/classnames';
import { useAppStore } from 'store';
import { useArrivalReceiptStore } from 'store/arrivalReceiptStore';
import { SCREEN_TYPES } from 'utils/constants';
import { getCurrentColors } from 'utils/getCurrentColor';

interface ArrivalDispositionSheetProps {
  className?: string;
}

export const ArrivalDispositionSheet = ({ className }: ArrivalDispositionSheetProps = {}) => {
  const { currentArrivalReceipt, setCurrentArrivalReceipt } = useArrivalReceiptStore();
  const { currentScreen } = useAppStore();

  const visible =
    currentScreen === SCREEN_TYPES.RECEIVING &&
    currentArrivalReceipt &&
    currentArrivalReceipt.responseState !== 'problem';

  if (!visible) return null;

  const arr = currentArrivalReceipt!;
  const { sheet, badge } = getCurrentColors(arr.arrival_disposition);

  return (
    <div
      className={cn(
        'border-t px-4 py-5 animate-in slide-in-from-bottom duration-200',
        sheet,
        className
      )}
    >
      <div className="flex items-center gap-3 mb-4">
        <span className="text-xs font-bold uppercase tracking-wide text-slate-500 shrink-0">
          Arrival
        </span>
        <span
          className={cn(
            'inline-flex rounded-full border px-3 py-1 text-sm font-bold uppercase tracking-wide',
            badge
          )}
        >
          {arr.arrival_disposition || 'Received'}
        </span>
        <button
          type="button"
          onClick={() => setCurrentArrivalReceipt(null)}
          className="ml-auto shrink-0 rounded-full p-1 text-slate-400 hover:bg-white/60 hover:text-slate-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500">
        {arr.rma_id && (
          <span>
            RMA: <span className="font-semibold text-slate-900">{arr.rma_id}</span>
          </span>
        )}
        {arr.expected_line_cnt != null && (
          <span>
            Expected: <span className="font-semibold text-slate-900">{arr.expected_line_cnt}</span>
          </span>
        )}
        {arr.receipt_status && (
          <span>
            Status: <span className="font-semibold text-slate-900">{arr.receipt_status}</span>
          </span>
        )}
      </div>
    </div>
  );
};
